// store/actions/Site.actions.ts
import { createAction, props } from '@ngrx/store';
import { Site, SiteRegistrationRequest, SiteUpdateRequest } from 'src/app/core/models/site.model';


export const loadSite = createAction('[Site] Load Site Types');
export const loadSites = createAction('[Site] Load Site Types');
export const loadSiteTypes = createAction('[Site] Load Site Types');
export const loadSiteType = createAction('[Site] Load Site Type');
export const loadSitesTypeSuccess = createAction(
  '[Site] Load Sites  Success',
  props<{ sites: Site[] }>()
);
export const loadSiteTypeSuccess = createAction(
  '[Site] Load Type Success',
  props<{ typeSite: string }>()
);
export const loadSiteTypesSuccess = createAction(
  '[Site] Load Types Success',
  props<{ typesSite: string[] }>()
);
export const loadSiteSuccess = createAction(
  '[Site] Load Site Success',
  props<{ site: Site }>()
);

// Add new site actions
export const addSite = createAction(
  '[Site] Add Site',
  props<{ siteData: SiteRegistrationRequest }>()
);

export const addSiteSuccess = createAction(
  '[Site] Add Site Success',
  props<{ site: Site }>()
);

export const addSiteFailure = createAction(
  '[Site] Add Site Failure',
  props<{ error: any }>()
);

// Edit site actions
export const editSite = createAction(
  '[Site] Edit Site',
  props<{ siteData: SiteUpdateRequest }>()
);

export const editSiteSuccess = createAction(
  '[Site] Edit Site Success',
  props<{ site: Site }>()
);

export const editSiteFailure = createAction(
  '[Site] Edit Site Failure',
  props<{ error: any }>()
);

// Update site logo actions
export const updateSiteLogo = createAction(
  '[Site] Update Site Logo',
  props<{ logoData: { logo: string; siteId: string } }>()
);

export const updateSiteLogoSuccess = createAction(
  '[Site] Update Site Logo Success',
  props<{ siteId: string; logoUrl: string }>()
);

export const updateSiteLogoFailure = createAction(
  '[Site] Update Site Logo Failure',
  props<{ error: any }>()
);

// Sync actions - REMOVED to prevent loops
// export const syncSitesWithAPI = createAction(...);
// export const syncSitesSuccess = createAction(...);
// export const syncSitesFailure = createAction(...);
// export const updateSitesFromComparison = createAction(...);
